import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import "react-modern-calendar-datepicker/lib/DatePicker.css"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import Select from "react-select"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import AddIcon from "@material-ui/icons/Add"
import FireNonIndustrialCov from "./FireNonIndustrialCov";
import FireIndustrialCov from "./FireIndustrialCov";
// import FireNonIndustrialCov from "./FireNonIndustrialCov";

const styles = (theme) => ({
    paperrtl: {
        marginTop: theme.spacing(0),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    paper: {
        display: "flex",
        flexWrap: "wrap",
        "& > *": {
            margin: theme.spacing(1),
            width: theme.spacing(20),
        },
    },
    root: {
        width: "100%",
        margin: "15px",
        padding: "8px",
        direction: "rtl",
    },
    container: {
        maxHeight: 400,
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    small: {
        width: theme.spacing(6),
        height: theme.spacing(6),
    },
})

class ChangePriceFireNonIndustrial extends Component {
    cookies = new Cookies()
    temp333
    constructor(props) {
        super(props)
        this.state = {
            redirect: false,
            errstr: "",
            errstatus: false,
            okstatus: false,
            requestinfos: [],
            agentInfofilter: [],
            rowsPerPage: 10,
            page: 0,
            Firenonindustrial_price_id: "",
            Firenonindustrial_price_buildpercent: "",
            Firenonindustrial_price_furniturepercent: "",
            Firenonindustrial_price_disc: "",
            selectedCompany: "",
            selectedKind: "",
            selectedTypeofcons: "",
            Firenonindustrial_price_deactive: "0",
            company_logo_url: "",
            orderBy: "Firenonindustrial_price_id",
            order: "desc",
            snackstr: "",
            showSnack: false,
            snackMode: "success",
            newPriceFireHome: true,
            optionCompany: [],
            optionKind: [],
            optionTypeofcons: [],
            openDialog: false,
            fireCovarages: [],
            Firenonindustrial_price_covarage_percent: "",
            selectedCoverage: "",
        }
    }

    handleClickOpen = () => {
        this.setState({
            openDialog: true,
        })
    }

    handleClose = () => {
        this.setState({
            openDialog: false,
        })
    }

    handleChangeForcedthird = (event) => {
        this.setState({ Firenonindustrial_price_buildpercent: event })
    }

    handleChangePassenger = (event) => {
        this.setState({ Firenonindustrial_price_furniturepercent: event })
    }

    handleChangeDisc = (event) => {
        this.setState({ Firenonindustrial_price_disc: event })
    }

    handleTypeofcons = (selectedTypeofcons) => {
        this.setState({ selectedTypeofcons: selectedTypeofcons }, () => {})
    }

    handleKind = (selectedKind) => {
        this.setState({ selectedKind: selectedKind }, () => {
            this.filterPriceFireHome()
        })
    }

    handleCompany = (selectedCompany) => {
        this.setState({ selectedCompany: selectedCompany }, () => {
            this.filterPriceFireHome()
        })
    }

    handleClickcloseTasckBar = (event) => {
        this.setState({ showSnack: false })
    }

    handleChangeDeactive = (event) => {
        if (event.target.checked) {
            this.setState({ Firenonindustrial_price_deactive: "0" })
        } else {
            this.setState({ Firenonindustrial_price_deactive: "1" })
        }
    }

    handleCoverage = (selectedCoverage) => {
        this.setState({ selectedCoverage: selectedCoverage })
    }


    handleChangeExtrafinancialPrice = (event) => {
        this.setState({ Firenonindustrial_price_covarage_percent: event })
    }

    handleSelectRows = (row2) => {
        this.getpriceCovarage(row2.firenonindustrial_price_id)
        this.setState(
            {
                Firenonindustrial_price_id: row2.firenonindustrial_price_id,
                Firenonindustrial_price_buildpercent: row2.firenonindustrial_price_buildpercent,
                Firenonindustrial_price_furniturepercent: row2.firenonindustrial_price_furniturepercent,
                Firenonindustrial_price_disc: row2.firenonindustrial_price_disc,

                selectedCompany: { value: row2.firenonindustrial_price_fieldcompany_id, label: row2.company_name, logo: row2.company_logo_url },
                selectedKind: { value: row2.firenonindustrial_price_kind_id, label: row2.firenonindustrial_kind_name },
                selectedTypeofcons: { value: row2.firenonindustrial_price_typeofcons_id, label: row2.firenonindustrial_typeofcons_name },

                Firenonindustrial_price_deactive: row2.firenonindustrial_price_deactive,
                company_logo_url: row2.company_logo_url,
                newPriceFireHome: false,
            },
            () => {}
        )
    }

    newPriceFireHome = (event) => {
        this.setState({
            Firenonindustrial_price_id: "",
            Firenonindustrial_price_buildpercent: "",
            Firenonindustrial_price_furniturepercent: "",
            Firenonindustrial_price_disc: "",
            selectedCompany: "",
            selectedKind: "",
            selectedTypeofcons: "",
            Firenonindustrial_price_deactive: "0",
            company_logo_url: "",
            newPriceFireHome: true,
        })
    }
    componentDidMount() {
        if (this.cookies.get("employee_token_str")) {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    if (arr.result === "ok") {
                        self.getoptionCompany()
                        // self.getoptionKind()
                        // self.getoptionTypeofcons()
                        self.getoptionCoverage()
                    } else if (arr.result === "error") {
                        self.setState({ redirect: true })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "checkemployeelogin")

            xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ redirect: true })
        }
    }

    deleteManagdiscount = () => {
        const { Firenonindustrial_price_id } = this.state
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        this.handleClose()
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                    //self.setState({ redirect: true })
                    self.getPriceFireHome()
                    self.newPriceFireHome()
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                })
            }
        }
        var fd = new FormData()
        fd.append("command", "delete_firenonindustrial_price")
        fd.append("firenonindustrial_price_id", Firenonindustrial_price_id)

        xhttp.open("POST", `${constants.BASE_URL}/FireNonIndustrial`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }

    getPriceFireHome() {
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                        self.filterPriceFireHome()
                    })
                } else if (arr.result === "error") {
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                })
            }
        }
        var fd = new FormData()
        fd.append("command", "get_firenonindustrial_price")

        xhttp.open("POST", `${constants.BASE_URL}/FireNonIndustrial`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }

    getpriceCovarage(Firenonindustrial_price_id) {
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        this.setState({ fireCovarages: [] }, () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    if (arr.result === "ok") {
                        self.setState({ fireCovarages: arr.data }, () => {})
                    } else if (arr.result === "error") {
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "get_price_covarage")
            fd.append("firenonindustrial_price_id", Firenonindustrial_price_id)

            xhttp.open("POST", `${constants.BASE_URL}/FireNonIndustrial`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        })
    }


    getoptionCompany = () => {
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    var Company = []
                    for (var k = 0; k < arr.data.length; k++) {
                        Company.push({
                            value: arr.data[k].fieldcompany_id,
                            label: arr.data[k].company_name,
                            logo: arr.data[k].company_logo_url,
                        })
                    }
                    self.setState({ optionCompany: Company, selectedCompany: Company[0] }, () => {
                        self.getPriceFireHome()
                    })
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
            }
        }
        var fd = new FormData()
        fd.append("command", "get_fieldcompany")
        fd.append("fieldinsurance", "firenonindustrialins")
        xhttp.open("POST", `${constants.BASE_URL}/fieldcompany`)
        xhttp.send(fd)
    }

    getoptionKind = () => {
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    var Company = []
                    for (var k = 0; k < arr.data.length; k++) {
                        Company.push({ value: arr.data[k].Firenonindustrial_kind_id, label: arr.data[k].Firenonindustrial_kind_name })
                    }
                    self.setState({ optionKind: Company }, () => {})
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
            }
        }
        var fd = new FormData()
        fd.append("command", "get_Firenonindustrial_kind")
        xhttp.open("POST", `${constants.BASE_URL}/Firenonindustrial`)
        xhttp.send(fd)
    }

    getoptionCoverage = () => {
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                console.log(this.responseText)
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    var Company = []
                    for (var k = 0; k < arr.data.length; k++) {
                        Company.push({ value: arr.data[k].coverage_id, label: arr.data[k].coverage_name })
                    }
                    self.setState({ optionCoverage: Company }, () => {})
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
            }
        }
        var fd = new FormData()
        fd.append("command", "get_coverage")
        xhttp.open("POST", `${constants.BASE_URL}/FireIndustrial`)
        xhttp.send(fd)
    }


    getoptionTypeofcons = () => {
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    var Company = []
                    for (var k = 0; k < arr.data.length; k++) {
                        Company.push({ value: arr.data[k].Firenonindustrial_typeofcons_id, label: arr.data[k].Firenonindustrial_typeofcons_name })
                    }
                    self.setState({ optionTypeofcons: Company }, () => {})
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
            }
        }
        var fd = new FormData()
        fd.append("command", "get_Firenonindustrial_typeofcons")
        xhttp.open("POST", `${constants.BASE_URL}/Firenonindustrial`)
        xhttp.send(fd)
    }

    saveNewPriceFireHome = () => {
        const {
            Firenonindustrial_price_buildpercent,
            Firenonindustrial_price_furniturepercent,
            Firenonindustrial_price_disc,
            selectedCompany,
            Firenonindustrial_price_deactive,
        } = this.state

        if (
            selectedCompany != "" &&
            Firenonindustrial_price_buildpercent != "" &&
            Firenonindustrial_price_furniturepercent != "" &&
            Firenonindustrial_price_disc != ""
        ) {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    if (arr.result === "ok") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        // self.getPriceFireHome()
                    } else if (arr.result === "error") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "add_firenonindustrial_price")
            fd.append("firenonindustrial_price_buildpercent", Firenonindustrial_price_buildpercent)
            fd.append("firenonindustrial_price_furniturepercent", Firenonindustrial_price_furniturepercent)
            fd.append("firenonindustrial_price_disc", Firenonindustrial_price_disc)
            fd.append("firenonindustrial_price_fieldcompany_id", selectedCompany.value)
            fd.append("firenonindustrial_price_deactive", Firenonindustrial_price_deactive)

            xhttp.open("POST", `${constants.BASE_URL}/FireNonIndustrial`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
        }
    }

    saveNewPriceCoverage = () => {
        const { Firenonindustrial_price_id, selectedCoverage, Firenonindustrial_price_covarage_percent } = this.state
        if (selectedCoverage != "" && Firenonindustrial_price_covarage_percent != "") {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    if (arr.result === "ok") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        self.setState({ Firenonindustrial_price_covarage_percent: "", selectedCoverage: "" })
                        self.getpriceCovarage(Firenonindustrial_price_id)
                    } else if (arr.result === "error") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "add_price_covarage")
            fd.append("firenonindustrial_price_covarage_firenonindustrial_price_id", Firenonindustrial_price_id)
            fd.append("firenonindustrial_price_covarage_percent", Firenonindustrial_price_covarage_percent)
            fd.append("firenonindustrial_price_covarage_fire_covarage_id", selectedCoverage.value)

            xhttp.open("POST", `${constants.BASE_URL}/FireNonIndustrial`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ snackstr: "لطفا مشخصات درصد پوشش را وارد نمایید", showSnack: true, snackMode: "error" })
        }
    }


    ChangePriceFireNonIndustrial = () => {
        const {
            Firenonindustrial_price_id,
            Firenonindustrial_price_buildpercent,
            Firenonindustrial_price_furniturepercent,
            Firenonindustrial_price_disc,
            selectedCompany,
            selectedKind,
            selectedTypeofcons,
            Firenonindustrial_price_deactive,
        } = this.state
        if (
            selectedCompany != "" &&
            selectedKind != "" &&
            selectedTypeofcons != "" &&
            Firenonindustrial_price_buildpercent != "" &&
            Firenonindustrial_price_furniturepercent != "" &&
            Firenonindustrial_price_disc != ""
        ) {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    if (arr.result === "ok") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        //self.setState({ redirect: true })
                        self.getPriceFireHome()
                    } else if (arr.result === "error") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "modify_firenonindustrial_price")
            fd.append("firenonindustrial_price_id", Firenonindustrial_price_id)
            fd.append("firenonindustrial_price_buildpercent", Firenonindustrial_price_buildpercent)
            fd.append("firenonindustrial_price_furniturepercent", Firenonindustrial_price_furniturepercent)
            fd.append("firenonindustrial_price_disc", Firenonindustrial_price_disc)

            fd.append("firenonindustrial_price_fieldcompany_id", selectedCompany.value)
            fd.append("firenonindustrial_price_kind_id", selectedKind.value)
            fd.append("firenonindustrial_price_typeofcons_id", selectedTypeofcons.value)
            fd.append("firenonindustrial_price_deactive", Firenonindustrial_price_deactive)

            xhttp.open("POST", `${constants.BASE_URL}/FireNonIndustrial`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
        }
    }

    createSortHandler = (field) => {
        if (this.state.orderBy === field) {
            if (this.state.order === "asc") {
                this.setState({ order: "desc" })
            } else {
                this.setState({ order: "asc" })
            }
        } else {
            this.setState({ orderBy: field, order: "asc" })
        }
        var arraytemp = [],
            i,
            j,
            temp,
            a,
            b
        arraytemp = this.state.agentInfofilter
        for (i = 0; i < arraytemp.length; i++) {
            for (j = 0; j < arraytemp.length - 1; j++) {
                a = arraytemp[j]
                b = arraytemp[j + 1]
                if (a[field] < b[field] && this.state.order === "asc") {
                    temp = arraytemp[j]
                    arraytemp[j] = arraytemp[j + 1]
                    arraytemp[j + 1] = temp
                } else if (a[field] > b[field] && this.state.order === "desc") {
                    temp = arraytemp[j]
                    arraytemp[j] = arraytemp[j + 1]
                    arraytemp[j + 1] = temp
                }
            }
        }
    }

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
    }

    handleChangePage = (event, number) => {
        this.setState({ page: parseInt(number, 0) })
    }
    filterPriceFireHome = () => {
        const { selectedCompany, selectedKind, requestinfos } = this.state
        var temparray = requestinfos,
            temparray2 = [],
            i
        for (i = 0; i < temparray.length; i++) {
            console.log('omad to for')
            console.log("selectedCompany.value",selectedCompany.value)
            console.log("temparray[i].firenonindustrial_price_fieldcompany_id",temparray[i].firenonindustrial_price_fieldcompany_id)

            if ((selectedCompany.value === 0 || temparray[i].firenonindustrial_price_fieldcompany_id === selectedCompany.value)) {

                temparray2.push(temparray[i])
            }
        }
        console.log('temparray2',temparray2)

        this.setState({ agentInfofilter: temparray2 }, () => {})
    }

    render() {
        const { classes } = this.props
        const {
            Firenonindustrial_price_covarage_percent,
            selectedCoverage,
            optionCompany,
            optionCoverage,
            optionKind,
            optionTypeofcons,
            fireCovarages,
            snackMode,
            snackstr,
            showSnack,
            newPriceFireHome,
            Firenonindustrial_price_id,
            Firenonindustrial_price_buildpercent,
            Firenonindustrial_price_furniturepercent,
            Firenonindustrial_price_disc,
            company_logo_url,
            selectedCompany,
            selectedKind,
            selectedTypeofcons,
            Firenonindustrial_price_deactive,
            order,
            orderBy,
            okstatus,
            errstr,
            redirect,
            agentInfofilter,
            rowsPerPage,
            page,
        } = this.state
        if (redirect) {
            return <Redirect to="/" />
        } else {
            return (
                <div className={classes.paperrtl} dir="ltr">
                    <Snackbar
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        onClose={this.handleClickcloseTasckBar}
                        open={showSnack}
                        autoHideDuration={10000}
                    >
                        <Alert severity={snackMode}>{snackstr}</Alert>
                    </Snackbar>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Container component="main" maxWidth="lg">
                                <Paper elevation={4} className={classes.root}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={6}>
                                            <Typography align="center" variant="h7">
                                                {"بیمه آتش‌سوزی غیرصنعتی – بانک صنعت و معدن: " + Firenonindustrial_price_id}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}></Grid>

                                        <Grid item xs={6}>
                                            <div>
                                                <label className="on">شرکت بیمه</label>
                                                <Select
                                                    isSearchable={true}
                                                    className="adapter-txtsize"
                                                    placeholder={"شرکت بیمه"}
                                                    value={selectedCompany}
                                                    onChange={this.handleCompany}
                                                    options={optionCompany}
                                                />
                                            </div>
                                        </Grid>

                                        <Grid item xs={6}>
                                            <div style={{ width: "100%", textAlign: "center" }}>
                                                <img alt="" className={classes.large} src={this.state.selectedCompany.logo} />
                                            </div>
                                        </Grid>

                                        {/*<Grid item xs={4}>*/}
                                        {/*    <div>*/}
                                        {/*        <label className="on">نوع ملک </label>*/}
                                        {/*        <Select*/}
                                        {/*            isSearchable={true}*/}
                                        {/*            className="adapter-txtsize"*/}
                                        {/*            placeholder={"نوع ملک "}*/}
                                        {/*            value={selectedKind}*/}
                                        {/*            onChange={this.handleKind}*/}
                                        {/*            options={optionKind}*/}
                                        {/*        />*/}
                                        {/*    </div>*/}
                                        {/*</Grid>*/}

                                        {/*<Grid item xs={4}>*/}
                                        {/*    <div>*/}
                                        {/*        <label className="on">نوع سازه </label>*/}
                                        {/*        <Select*/}
                                        {/*            isSearchable={true}*/}
                                        {/*            className="adapter-txtsize"*/}
                                        {/*            placeholder={"نوع سازه"}*/}
                                        {/*            value={selectedTypeofcons}*/}
                                        {/*            onChange={this.handleTypeofcons}*/}
                                        {/*            options={optionTypeofcons}*/}
                                        {/*        />*/}
                                        {/*    </div>*/}
                                        {/*</Grid>*/}

                                        <Grid item xs={4}>
                                            <FloatingLabelInput
                                                type="percent"
                                                placeholder="نرخ حق آصا"
                                                handleInputt={this.handleChangeForcedthird}
                                                value={Firenonindustrial_price_buildpercent}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FloatingLabelInput
                                                type="percent"
                                                placeholder="نرخ حق بیمه اثاثیه"
                                                handleInputt={this.handleChangePassenger}
                                                value={Firenonindustrial_price_furniturepercent}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FloatingLabelInput
                                                type="percent"
                                                placeholder="تخفیف"
                                                handleInputt={this.handleChangeDisc}
                                                value={Firenonindustrial_price_disc}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <div style={{ width: "100%", textAlign: "center" }}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={Firenonindustrial_price_deactive === "0" ? true : false}
                                                            onChange={this.handleChangeDeactive}
                                                            name="gilad"
                                                        />
                                                    }
                                                    label="وضعیت قیمت شرکت بیمه"
                                                />
                                            </div>
                                        </Grid>

                                        <Grid item xs={12}>
                                            {newPriceFireHome ? (
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={this.saveNewPriceFireHome}
                                                >
                                                    {"ثبت قیمت بیمه آتش سوزی مسکونی جدید "}
                                                </Button>
                                            ) : (
                                                <div style={{ width: "100%", textAlign: "right" }}>
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={this.newPriceFireHome}
                                                    >
                                                        {"قیمت بیمه آتش سوزی مسکونی جدید "}
                                                    </Button>
                                                    {"          "}
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={this.ChangePriceFireNonIndustrial}
                                                    >
                                                        {"ثبت تغییرات"}
                                                    </Button>
                                                    {"          "}
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={(e) => {
                                                            this.handleClickOpen()
                                                        }}
                                                    >
                                                        {" حذف قیمت بیمه آتش سوزی مسکونی"}
                                                    </Button>
                                                </div>
                                            )}
                                        </Grid>

                                        {newPriceFireHome ? null : (
                                            <Grid item xs={12}>
                                                <Divider />
                                            </Grid>
                                        )}
                                    </Grid>
                                </Paper>
                            </Container>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Container>
                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                    {newPriceFireHome ? null : (
                                        <Grid item xs={12}>
                                            {fireCovarages.map((fireCovarages, index) => (
                                                <FireNonIndustrialCov
                                                    key={fireCovarages.firehome_price_covarage_id || index}
                                                    fireCovarages={fireCovarages}
                                                    optionCoverage={optionCoverage} // پاس بده به فرزند
                                                    props={this.props}
                                                />
                                            ))}
                                        </Grid>
                                    )}
                                </Paper>

                                <Paper className={classes.root}>
                                    {newPriceFireHome ? null : (
                                        <Grid item xs={12}>
                                            <Grid container spacing={3}>
                                                <Grid item xs={5}>
                                                    <div>
                                                        <label className="on"> پوشش بیمه</label>
                                                        <Select
                                                            isSearchable={true}
                                                            className="adapter-txtsize"
                                                            placeholder={"پوشش بیمه"}
                                                            value={selectedCoverage}
                                                            onChange={this.handleCoverage}
                                                            options={optionCoverage}
                                                        />
                                                    </div>
                                                </Grid>

                                                <Grid item item xs={4}>
                                                    <FloatingLabelInput
                                                        type="percent"
                                                        placeholder="درصد پوشش"
                                                        handleInputt={this.handleChangeExtrafinancialPrice}
                                                        value={Firenonindustrial_price_covarage_percent}
                                                    />
                                                </Grid>

                                                <Grid item item xs={3}>
                                                    <div style={{ width: "100%", textAlign: "left" }}>
                                                        <Fab
                                                            className={classes.small}
                                                            color="primary"
                                                            aria-label="add"
                                                            onClick={this.saveNewPriceCoverage}
                                                        >
                                                            <AddIcon />
                                                        </Fab>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )}
                                </Paper>
                            </Container>
                        </Grid>


                        <Grid item xs={12}>
                            <Container maxWidth="lg">
                                <Paper className={classes.root}>
                                    <TableContainer dir="rtl">
                                        <Table aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell
                                                        key={"firenonindustrial_price_id"}
                                                        align={"center"}
                                                        style={{ minWidth: 20 }}
                                                        sortDirection={orderBy === "firenonindustrial_price_id" ? order : false}
                                                    >
                                                        {" آی دی تخفیف"}
                                                        <TableSortLabel
                                                            active={orderBy === "firenonindustrial_price_id"}
                                                            direction={orderBy === "firenonindustrial_price_id" ? order : "asc"}
                                                            onClick={(e) => {
                                                                this.createSortHandler("firenonindustrial_price_id")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"company_name"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"شرکت بیمه  "}
                                                        <TableSortLabel
                                                            active={orderBy === "company_name"}
                                                            direction={orderBy === "company_name" ? order : "asc"}
                                                            onClick={(e) => {
                                                                this.createSortHandler("company_name")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>


                                                    <TableCell
                                                        key={"firenonindustrial_price_buildpercent"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"نرخ حق آصا"}
                                                        <TableSortLabel
                                                            active={orderBy === "firenonindustrial_price_buildpercent"}
                                                            direction={
                                                                orderBy === "firenonindustrial_price_buildpercent"
                                                                    ? order
                                                                    : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("firenonindustrial_price_buildpercent")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"firenonindustrial_price_furniturepercent"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"نرخ حق بیمه اثاثیه"}
                                                        <TableSortLabel
                                                            active={orderBy === "firenonindustrial_price_furniturepercent"}
                                                            direction={
                                                                orderBy === "firenonindustrial_price_furniturepercent"
                                                                    ? order
                                                                    : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler(
                                                                    "firenonindustrial_price_furniturepercent"
                                                                )
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"firenonindustrial_price_disc"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تخفیف"}
                                                        <TableSortLabel
                                                            active={orderBy === "firenonindustrial_price_disc"}
                                                            direction={
                                                                orderBy === "firenonindustrial_price_disc" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("firenonindustrial_price_disc")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"firenonindustrial_price_deactive"}
                                                        align={"center"}
                                                        style={{ minWidth: 20 }}
                                                    >
                                                        {"وضعیت قیمت بیمه آتش سوزی مسکونی"}
                                                        <TableSortLabel
                                                            active={orderBy === "firenonindustrial_price_deactive"}
                                                            direction={
                                                                orderBy === "firenonindustrial_price_deactive" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("firenonindustrial_price_deactive")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {agentInfofilter
                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    .map((row) => {

                                                        {console.log("row",row)}
                                                        return (
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                                key={row["firenonindustrial_price_id"]}
                                                                value={row}
                                                                onClick={() => {
                                                                    this.handleSelectRows(row)
                                                                }}
                                                            >
                                                                <TableCell key={"firenonindustrial_price_id"} align={"center"}>
                                                                    {row["firenonindustrial_price_id"]}
                                                                </TableCell>

                                                                <TableCell key={"company_name"} align={"center"}>
                                                                    {row["company_name"]}
                                                                    <img
                                                                        className={classes.small}
                                                                        alt="Remy Sharp"
                                                                        src={row["company_logo_url"]}
                                                                    />
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"firenonindustrial_price_buildpercent"}
                                                                    align={"center"}
                                                                >
                                                                    {row["firenonindustrial_price_buildpercent"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"firenonindustrial_price_furniturepercent"}
                                                                    align={"center"}
                                                                >
                                                                    {row["firenonindustrial_price_furniturepercent"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"firenonindustrial_price_disc"}
                                                                    align={"center"}
                                                                >
                                                                    {row["firenonindustrial_price_disc"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"firenonindustrial_price_deactive"}
                                                                    align={"center"}
                                                                >
                                                                    {row["firenonindustrial_price_deactive"] === "1" ||
                                                                    row["firenonindustrial_price_deactive"] === 1 ? (
                                                                        <Fab variant="extended">
                                                                            <VoiceOverOffIcon />
                                                                            {"غیر فعال"}
                                                                        </Fab>
                                                                    ) : (
                                                                        <Fab
                                                                            variant="extended"
                                                                            style={{ background: "#44b700" }}
                                                                        >
                                                                            <RecordVoiceOverIcon />
                                                                            {"فعال"}
                                                                        </Fab>
                                                                    )}
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                    })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 25, 100]}
                                        component="div"
                                        count={agentInfofilter.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </Paper>
                            </Container>
                        </Grid>
                    </Grid>

                    {okstatus ? (
                        <Alert severity="success">
                            <AlertTitle>پیام</AlertTitle>
                            {errstr}
                        </Alert>
                    ) : null}
                    <Dialog
                        open={this.state.openDialog}
                        onClose={this.handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{"آیا میخواهید قیمت بیمه آتش سوزی مسکونی را حذف نمایید"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                انصراف
                            </Button>
                            <Button onClick={this.deleteManagdiscount} color="primary" autoFocus>
                                بله انجام شود
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )
        }
    }
}

export default withStyles(styles)(ChangePriceFireNonIndustrial)
